
<script>
// const base = 'https://dev.hzdlstudy.com:8181/'
const base = 'https://dev.hzdlstudy.com'

export default {
  base
}

</script>
